import _ from "lodash";
import Helper from './Helper';
class ProductHelper{
    static getFilterProducts(products)
    {
        let tempData = products['items'];
        // ordering
        let sort = Helper.getUrlParam('sort') ?? 'newest', sortKey = 'meta.create_time', sortType = 'desc';
        switch (sort) {
            case 'newest':
                sortKey = 'meta.create_time';
                sortType = 'desc';
                break;
            case 'price_asc':
                sortKey = 'meta.price';
                sortType = 'asc';
                break;
            case 'price_desc':
                sortKey = 'meta.price';
                sortType = 'desc';
                break;
            default:
                break;
        }
        tempData = _.orderBy(tempData,[sortKey],[sortType]);
        // End ordering
        let limit = Helper.getUrlParam('limit')??12,
        page = Helper.getUrlParam('page')??1,
        total = tempData.length;
        limit = parseInt(limit);
        page = parseInt(page);
        
        let totalPage = Math.ceil(total/limit);
        page = page > totalPage ? totalPage :page;
        let start = limit * (page - 1), end = start + limit - 1;
        end = end > tempData.length ? tempData.length : end;
        tempData = tempData.slice(start, (end + 1));
        return {
            total:total,
            page: page,
            limit: limit,
            items:tempData
        };        
    }
}
export default ProductHelper